<template>
    <div class="summary-card">
        <div class="stretch-area">
            <div class="summary-card-button">
                <!-- Treatment Summary Button Section -->
                <template v-if="treatment.start === 0 && !_isTvView">
                    <button
                        type="button"
                        class="btn btn-secondary mb-1"
                        @click="start"
                    >
                        Start
                    </button>
                    <button
                        type="button"
                        class="btn btn-secondary"
                        @click="removeTreatment"
                    >
                        Remove
                    </button>
                </template>
                <template
                    v-if="
                        treatment.start > 0 &&
                        status.status_id > TREATMENT_STATUS.ADMITTED &&
                        !_isTvView
                    "
                >
                    <button
                        type="button"
                        class="btn btn-secondary"
                        @click="end"
                    >
                        End
                    </button>
                </template>
            </div>
        </div>
        <hr
            v-if="
                !_isTvView &&
                treatment.start > 1 &&
                (status.status_id > TREATMENT_STATUS.ADMITTED ||
                    activitiesOverdue.length > 0)
            "
            class="w-100"
        />
        <div class="stretch-area">
            <div class="summary-card-navlink">
                <!-- Treatment Summary related to documents and overdue Info Section -->
                <a
                    v-if="
                        status.status_id !== TREATMENT_STATUS.ADMITTED &&
                        status.status_id !== TREATMENT_STATUS.PRETREATMENT
                    "
                    href="documents"
                    @click.prevent="document_dialog()"
                >
                    Documents
                </a>
                <a
                    v-if="
                        activitiesOverdue.length > 0 &&
                        status.status_id !== TREATMENT_STATUS.ADMITTED
                    "
                    :href="'javascript:void(0)'"
                    :id="`${cellId}_overdue_summary`"
                >
                    {{ activitiesOverdue.length }}&nbsp;Overdue&nbsp;
                </a>
            </div>
        </div>
        <activity-list-group
            v-if="
                activitiesOverdue.length > 0 &&
                status.status_id !== TREATMENT_STATUS.ADMITTED
            "
            :treatment="treatment"
            :target="`${cellId}_overdue_summary`"
            :activities="activitiesOverdue"
            :prepareDateTime="prepareDateTime"
            :dialogs="dialogs"
            :placement="'rightBottom'"
            ref="activityListPopover"
            :parentRef="parentRef"
            :labelOptions="labelOptions"
        >
        </activity-list-group>
    </div>
</template>
<script>
import ScheduleHelper from "../helper";
import { some, find } from "lodash";
import ActivityListGroup from "./treatment-activity-list-popover";

export default {
    name: "TreatmentSummaryDetails",
    mixins: [ScheduleHelper],
    components: {
        ActivityListGroup
    },
    props: {
        treatment: {
            type: Object,
            default() {
                return {};
            }
        },
        activities: {
            type: Object,
            default() {
                return {};
            }
        },
        cellId: {
            type: String,
            default: "cell"
        },
        status: {
            type: Object,
            default() {
                return {};
            }
        },
        prepareDateTime: {
            type: Function
        },
        dialogs: {
            type: Object,
            default() {
                return {};
            }
        },
        parentRef: {
            type: HTMLDivElement,
            default() {
                return null;
            }
        },
        labelOptions: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            documents: [],
            activitiesOverdue: []
        };
    },
    watch: {
        activities: {
            handler(value) {
                this.activitiesOverdue = value.overdue;
            },
            immediate: true // Trigger the handler on initial load
        }
    },
    mounted() {},
    methods: {
        document_dialog() {
            this.dialogs["documentModal"].open(this.treatment);
        },
        overdue_dialog(activity) {
            this.$refs.activityListPopover.openModal(activity);
        },
        start() {
            if (
                this._hasAccess("schedule.treatmentboard.start") &&
                !this._isTvView
            ) {
                this.dialogs["startModal"].open({
                    patient: this.treatment.patient,
                    clientID: this.treatment.client_id,
                    treatmentID: this.treatment.id,
                    treatment: this.treatment,
                    weight: find(this.vitals, { type: 4 })
                });
            }
        },
        removeTreatment() {
            this.dialogs["removeTreatmentModal"].open({
                ...this.treatment
            });
        },
        end() {
            if (
                this._hasAccess("schedule.treatmentboard.end") &&
                !this._isTvView
            ) {
                this.dialogs["dischargeModal"].open({
                    ...this.treatment,
                    status: some(
                        this.treatment.activities.filter(
                            activity =>
                                activity.status ===
                                this.TREATMENT_ACTIVITY_STATUS.PENDING
                        )
                    )
                        ? this.TREATMENT_STATUS.CANCELLED
                        : this.TREATMENT_STATUS.DISCHARGED
                });
            }
        }
    }
};
</script>
<style scoped>
.summary-card {
    display: flex; /* d-flex */
    flex-direction: column; /* flex-column */
    justify-content: flex-start; /* justify-content-start */
    align-items: center; /* align-items-center */
}
.summary-card-button,
.summary-card-navlink {
    display: flex; /* d-flex */
    flex-direction: column; /* flex-column */
}
.summary-card-button {
    align-items: stretch; /* align-items-stretch */
}
.summary-card-navlink {
    align-items: center; /* align-items-center */
}
.stretch-area {
    width: -webkit-fill-available;
}
</style>
